import { createApi } from '@reduxjs/toolkit/query/react';
import { type TreatmentStatusIndicator } from '@strata/react-status-indicators';

import { TREATMENT_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const treatmentApi = createApi({
    baseQuery: getBaseQuery(TREATMENT_API_URL),
    reducerPath: 'treatmentApi',
    endpoints: (build) => ({
        getTreatmentsForPatient: build.query<
            {
                treatment_id: string;
                product_service_oid: string;
                treatment_status: (typeof TreatmentStatusIndicator.Statuses)[keyof typeof TreatmentStatusIndicator.Statuses];
            }[],
            {
                payerId: string;
                segmentId: string;
                memberId: string;
                patientFirstName: string;
                patientLastName: string;
                patientDob: string | Date;
            }
        >({
            query: ({
                payerId,
                segmentId,
                memberId,
                patientFirstName,
                patientLastName,
                patientDob,
            }) => ({
                url: `${payerId}/treatments`,
                params: {
                    segment_id: segmentId,
                    member_id: memberId,
                    patient_first_name: patientFirstName,
                    patient_last_name: patientLastName,
                    patient_dob: patientDob,
                },
            }),
            transformErrorResponse: handleRTKQueryError(
                'An error occurred retrieving treatments for member.',
            ),
        }),
    }),
});

export const { useGetTreatmentsForPatientQuery, useLazyGetTreatmentsForPatientQuery } =
    treatmentApi;
